import type { ReactNode } from 'react';

export const symbol_float_portrait_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-530h210q12.75 0 21.38-8.63Q550-547.25 550-560v-170q0-12.75-8.62-21.38Q532.75-760 520-760H310q-12.75 0-21.37 8.62Q280-742.75 280-730v170q0 12.75 8.63 21.37Q297.25-530 310-530Zm490 390q0 24-18 42t-42 18H220q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680Zm-60 0v-680H220v680h520Zm0-680H220h520Z"
		/>
	</svg>
);
